import axios from 'axios';
import React, { useContext, useEffect, useReducer } from 'react';
import reducer from '../reducers/products_reducer';
import { products_url } from '../utils/constants';
import {
  SIDEBAR_OPEN,
  SIDEBAR_CLOSE,
  GET_PRODUCTS_BEGIN,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_ERROR,
  GET_SINGLE_PRODUCT_BEGIN,
  GET_SINGLE_PRODUCT_SUCCESS,
  GET_SINGLE_PRODUCT_ERROR,
} from '../actions';

const initialState = {
  isSidebarOpen: false,
  products_loading: false,
  products_error: false,
  products: [],
  featured_products: [],
  single_product_loading: false,
  single_product_error: false,
  single_product: {},
};

const ProductsContext = React.createContext();

export const ProductsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const openSidebar = function () {
    dispatch({ type: SIDEBAR_OPEN });
  };

  const closeSidebar = function () {
    dispatch({ type: SIDEBAR_CLOSE });
  };

  const fetchProducts = async function (url) {
    dispatch({ type: GET_PRODUCTS_BEGIN });

    try {
      const { data } = await axios(url);
      dispatch({ type: GET_PRODUCTS_SUCCESS, payload: { products: data } });
    } catch (error) {
      console.error(error.response);
      dispatch({ type: GET_PRODUCTS_ERROR });
    }
  };

  const fetchSingleProduct = async function (url) {
    dispatch({ type: GET_SINGLE_PRODUCT_BEGIN });
    try {
      const res = await axios(url);
      const data = await res.data;

      dispatch({
        type: GET_SINGLE_PRODUCT_SUCCESS,
        payload: { singleProduct: data },
      });
    } catch (error) {
      console.error(error.response);
      dispatch({ type: GET_SINGLE_PRODUCT_ERROR });
    }
  };

  useEffect(() => {
    fetchProducts(products_url);
  }, []);

  return (
    <ProductsContext.Provider
      value={{ openSidebar, closeSidebar, ...state, fetchSingleProduct }}
    >
      {children}
    </ProductsContext.Provider>
  );
};
// make sure use
export const useProductsContext = () => {
  return useContext(ProductsContext);
};
